// API Configuration - determines API URL based on current hostname

const getApiUrl = (): string => {
  // Determine based on hostname
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

  if (hostname.includes('staging')) {
    return 'https://devfactory-api-staging.yassine-techini.workers.dev';
  }

  if (hostname.includes('dev')) {
    return 'https://devfactory-api-dev.yassine-techini.workers.dev';
  }

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Local dev - use staging API for testing
    return 'https://devfactory-api-staging.yassine-techini.workers.dev';
  }

  // Production
  return 'https://devfactory-api.yassine-techini.workers.dev';
};

export const config = {
  apiUrl: getApiUrl(),
};

export default config;
